import React from 'react';
import { useTripContext } from '../../contexts/TripContext';

/**
 * HeroSection - Hero area with title (departure city fixed to Singapore)
 */
const HeroSection = () => {
  const { getDepartureCityDisplay } = useTripContext();

  return (
    <div className="hero-section">
      <h1 className="hero-title">
        Explore the world with <strong>AI Travel Agent</strong>
      </h1>
      
      <div className="hero-subtitle">
        <span>from</span>
        <div className="departure-display">
          <strong>{getDepartureCityDisplay()}</strong>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
